  <app-admin-student-platform-header></app-admin-student-platform-header>

  <section class="user-management">
    <div *ngIf="!showDetailedView">
    <div class="header">
      <div>
        <h1 class="page-title">Company Approvals</h1>
        <p class="subtitle">
          {{ total }} companies in your review queue ·
          {{ pendingCount }} pending, {{ needClarificationCount }} need
          clarification, {{ rejectedCount }} rejected.
        </p>
      </div>
    </div>

    <div class="table-wrapper">
      <div class="search-filter-row">
        <div class="search-box">
          <span class="material-icons">search</span>
          <input
            type="text"
            placeholder="Search company, contact, email..."
            [(ngModel)]="searchTerm"
            (input)="onSearch()"
          />
        </div>

        <div class="date-filter">
          <span class="material-icons" style="color: #64748b; font-size: 20px"
            >calendar_today</span
          >
          <input
            type="date"
            [(ngModel)]="selectedDate"
            (change)="onDateChange()"
            style="
              border: none;
              outline: none;
              font-size: 14px;
              color: #1e293b;
              background: transparent;
              cursor: pointer;
            "
          />
          <button
            *ngIf="selectedDate"
            (click)="clearDateFilter()"
            style="
              border: none;
              background: transparent;
              cursor: pointer;
              display: flex;
              align-items: center;
              padding: 0;
            "
          >
            <span class="material-icons" style="font-size: 16px; color: #94a3b8"
              >close</span
            >
          </button>
        </div>

        <!-- Industry Dropdown -->
        <div class="select-wrapper" style="margin-right: auto">
          <select
            [(ngModel)]="selectedIndustry"
            (change)="onIndustryChange()"
            class="filter-select"
          >
            <option value="">All Industries</option>
            <option *ngFor="let industry of industries" [value]="industry">
              {{ industry }}
            </option>
          </select>
        </div>

        <button class="export-btn" (click)="exportToExcel()">
          <span class="material-icons">download</span>
          Export
        </button>
      </div>

      <ng-container *ngIf="isLoading; else listContent">
        <div class="app-spinner">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
      </ng-container>

      <ng-template #listContent>
        <ng-container *ngIf="companiesData.length > 0; else showMessage">
          <div class="table-container">
              <table>
                <thead>
                  <tr>
                    <th>
                      <div
                        class="header-cell-sort"
                        (click)="sortBy('company_name')"
                      >
                        Company
                        <span class="material-icons sort-icon">swap_vert</span>
                      </div>
                    </th>
                    <th>CONTACT</th>
                    <th>OFFICIAL EMAIL</th>
                    <th>MOBILE</th>
                    <th>
                      <div
                        class="header-cell-sort"
                        (click)="sortBy('submitted_at')"
                      >
                        Submitted
                        <span class="material-icons sort-icon">swap_vert</span>
                      </div>
                    </th>
                    <th>STATUS</th>
                    <th></th>
                    <th class="actions-col" style="text-align: right"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let company of companiesData">
                    <td class="company-cell">
                    <div
                      class="avatar"
                      [style.background-color]="
                        company.logo_url ? 'transparent' : '#6366f1'
                      "
                    >
                      <img
                        *ngIf="company.logo_url"
                        [src]="company.logo_url"
                        alt="Logo"
                        class="company-logo-img"
                      />
                        <span *ngIf="!company.logo_url">
                          {{ company.company_name.substring(0, 2).toUpperCase() }}
                        </span>
                      </div>
                      <div>
                        <strong class="company-name">{{
                          company.company_name
                        }}</strong>
                      <span class="company-industry">{{
                        company.industry
                      }}</span>
                      </div>
                    </td>
                    <td class="contact-cell">
                    <strong class="contact-name">{{
                      company.poc_phone
                    }}</strong>
                      <span class="contact-email">{{ company.poc_email }}</span>
                    </td>
                    <td>{{ company.official_email }}</td>
                    <td>{{ company.poc_phone }}</td>
                    <td>
                      {{ company.submitted_at | date: "dd MMM yyyy" }}
                    </td>
                    <td>
                      <span
                        class="badge-dot"
                        [ngClass]="{
                          pending: company.status === 'pending',
                          approved: company.status === 'approved',
                          rejected: company.status === 'rejected',
                          blocked: company.status === 'blocked',
                        need_clarification:
                          company.status === 'need_clarification',
                      }"
                    >
                      <span class="dot"></span>
                      {{
                        company.status === "need_clarification"
                          ? "need clarification"
                          : company.status
                      }}
                      </span>
                    </td>
                    <td style="text-align: center; width: 3rem">
                      <button
                        class="icon-action-btn"
                      (click)="
                        goToCompanyApprovalDetailPage(company.company_id)
                      "
                        matTooltip="View Details"
                      >
                        <span class="material-icons eye-icon">visibility</span>
                      </button>
                    </td>
                    <td class="actions-col" style="text-align: right">
                      <div class="action-buttons-group">
                        <button
                          *ngIf="company.status === 'pending'"
                          class="approve-btn"
                          (click)="openApproveModal(company)"
                        >
                          <span class="material-icons">check</span>
                          Approve
                        </button>
                        <button
                          *ngIf="company.status === 'pending'"
                          class="reject-btn"
                          (click)="openRejectModal(company)"
                        >
                          <span class="material-icons">close</span>
                          Reject
                        </button>
                        <button
                          *ngIf="company.status === 'pending'"
                          class="clarification-btn"
                          (click)="openClarificationModal(company)"
                        >
                          <span class="material-icons">priority_high</span>
                          Need Clarification
                        </button>
                        <!-- for need_clarification status -->
                        <button
                          *ngIf="company.status === 'need_clarification'"
                          class="view-comment-btn"
                          (click)="openViewClarificationModal(company)"
                        >
                          <span class="material-icons">chat_bubble_outline</span>
                          View Comment
                        </button>

                        <!-- for rejected status -->
                        <button
                          *ngIf="company.status === 'rejected'"
                          class="view-reason-btn"
                          (click)="openViewReasonModal(company)"
                        >
                          <span class="material-icons">info_outline</span>
                          View Reason
                        </button>

                        <span
                        *ngIf="
                          company.status !== 'pending' &&
                          company.status !== 'need_clarification' &&
                          company.status !== 'rejected'
                        "
                         class="processed-text"
                      >
                          Processed
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="pagination-row">
              <div class="showing-text">
                Showing {{ showingFrom }} - {{ showingTo }} of {{ total }}
              </div>
              <div class="pagination-controls">
                <button
                  class="pag-btn"
                  [disabled]="page === 1"
                  (click)="prevPage()"
                >
                  <span class="material-icons">chevron_left</span>
                </button>
                <span class="page-indicator"
                  >Page {{ page }} / {{ totalPages }}</span
                >
                <button
                  class="pag-btn"
                  [disabled]="page === totalPages"
                  (click)="nextPage()"
                >
                  <span class="material-icons">chevron_right</span>
                </button>
              </div>
            </div>
        </ng-container>
      </ng-template>
    </div>
  </div>
  <div
    class="detailed-view-container"
    *ngIf="selectedCompany && showDetailedView"
  >
    <button class="back-link-btn" (click)="closeViewModal()">
      <span class="material-icons">arrow_back</span>
      All companies
    </button>
    <div class="company-header-row">
      <div class="company-brand">
        <div
          class="big-avatar"
          [style.background-color]="
            selectedCompany.logo_url ? 'transparent' : '#6366f1'
          "
        >
          <img
            *ngIf="selectedCompany.logo_url"
            [src]="selectedCompany.logo_url"
            alt="Logo"
            class="company-logo-img"
          />
          <span *ngIf="!selectedCompany.logo_url">
            {{ selectedCompany.company_name.substring(0, 2).toUpperCase() }}
          </span>
        </div>
        <div>
          <div class="title-status-row">
            <h1 class="detailed-company-name">
              {{ selectedCompany.company_name }}
            </h1>
            <span
              class="badge-dot"
              [ngClass]="{
                pending: selectedCompany.status === 'pending',
                approved: selectedCompany.status === 'approved',
                rejected: selectedCompany.status === 'rejected',
                blocked: selectedCompany.status === 'blocked',
              }"
            >
              <span class="dot"></span>
              {{ selectedCompany.status }}
            </span>
          </div>
          <p class="company-meta-subtitle">
            {{ selectedCompany.industry }} &middot; Joined
            {{ selectedCompany.submitted_at | date: "dd MMM yyyy" }}
          </p>
        </div>
      </div>
      <div class="header-actions">
        <button
          class="btn-action-outline approve"
          *ngIf="selectedCompany.status === 'pending'"
          (click)="openApproveModal(selectedCompany)"
        >
          Approve
        </button>
        <button
          class="btn-action-outline block"
          *ngIf="selectedCompany.status === 'pending'"
          (click)="openRejectModal(selectedCompany)"
        >
          Block
        </button>
      </div>
    </div>
  </div>
</section>
<div class="modal-backdrop" *ngIf="showApproveModal">
  <div class="modal-card">
    <button class="modal-close-btn" (click)="closeApproveModal()">
      <span class="material-icons">close</span>
    </button>
    <h2 class="modal-title">Approve {{ selectedCompany?.company_name }}?</h2>
    <p class="modal-body">
      They will be able to post jobs and access the company dashboard. An
      approval email will be sent to
      <span class="highlight">{{ selectedCompany?.poc_email }}</span
      >.
    </p>
    <div class="modal-footer">
      <button class="btn-cancel" (click)="closeApproveModal()">Cancel</button>
      <button
        class="btn-confirm-approve"
        (click)="confirmApproval()"
        [disabled]="isApprovalLoading"
      >
        {{ isApprovalLoading ? "Approving..." : "Confirm approval" }}
      </button>
    </div>
  </div>
</div>
<div class="modal-backdrop" *ngIf="showRejectModal">
  <div class="modal-card">
    <button class="modal-close-btn" (click)="closeRejectModal()">
      <span class="material-icons">close</span>
    </button>
    <h2 class="modal-title">Reject {{ selectedCompany?.company_name }}</h2>
    <p class="modal-body">
      Your message will be emailed to
      <span class="highlight">{{ selectedCompany?.poc_email }}</span
      >.
    </p>
    <div class="form-group">
      <label class="form-label">Reason for rejection</label>
      <textarea
        class="form-textarea"
        rows="4"
        placeholder="Share why this company isn't a fit right now..."
        [(ngModel)]="rejectionReason"
      >
      </textarea>
    </div>
    <div class="modal-footer">
      <button class="btn-cancel" (click)="closeRejectModal()">Cancel</button>
      <button
        class="btn-confirm-reject"
        (click)="confirmRejection()"
        [disabled]="
          isApprovalLoading ||
          !rejectionReason ||
          rejectionReason.trim().length < 5
        "
      >
        {{ isApprovalLoading ? "Rejecting..." : "Send rejection" }}
      </button>
    </div>
  </div>
</div>
<div class="modal-backdrop" *ngIf="showClarificationModal">
  <div class="modal-card">
    <button class="modal-close-btn" (click)="closeClarificationModal()">
      <span class="material-icons">close</span>
    </button>
    <h2 class="modal-title">
      Request Clarification from {{ selectedCompany?.company_name }}
    </h2>
    <p class="modal-body">
      Your clarification request will be emailed to
      <span class="highlight">{{ selectedCompany?.poc_email }}</span
      >.
    </p>
    <div class="form-group">
      <label class="form-label">Clarification required details</label>
      <textarea
        class="form-textarea"
        rows="4"
        placeholder="Specify what clarification is needed from this company..."
        [(ngModel)]="clarificationReason"
      >
      </textarea>
    </div>
    <div class="modal-footer">
      <button class="btn-cancel" (click)="closeClarificationModal()">
        Cancel
      </button>
      <button
        class="btn-confirm-reject"
        (click)="confirmClarification()"
        [disabled]="
          isApprovalLoading ||
          !clarificationReason ||
          clarificationReason.trim().length < 5
        "
      >
        {{ isApprovalLoading ? "Sending..." : "Send request" }}
      </button>
    </div>
  </div>
</div>
<div class="modal-backdrop" *ngIf="showViewReasonModal && selectedCompany">
  <div class="modal-card reason-modal">
    <button class="modal-close-btn" (click)="closeViewReasonModal()">
      <span class="material-icons">close</span>
    </button>

    <div class="modal-company-header">
      <div
        class="avatar"
        [style.background-color]="
          selectedCompany.logo_url ? 'transparent' : '#6366f1'
        "
      >
        <img
          *ngIf="selectedCompany.logo_url"
          [src]="selectedCompany.logo_url"
          alt="Logo"
          class="company-logo-img"
        />
        <span *ngIf="!selectedCompany.logo_url">
          {{ selectedCompany.company_name.substring(0, 2).toUpperCase() }}
        </span>
      </div>
      <div class="company-info">
        <h2 class="modal-title">{{ selectedCompany.company_name }}</h2>
        <p class="company-industry">{{ selectedCompany.industry }}</p>
      </div>
    </div>
    <div class="status-section">
      <span class="status-label" style="margin-right: 8px">STATUS</span>
      <span class="badge-dot rejected">
        <span class="dot"></span>
        {{ selectedCompany.status }}
      </span>
    </div>
    <div class="reason-content-box rejection-box">
      <div class="reason-header">
        <span class="material-icons reason-icon">cancel</span>
        <span class="reason-title">REASON FOR REJECTION</span>
      </div>
      <p class="reason-text">
        {{ selectedCompany.rejection_reason || "No reason provided." }}
      </p>
      <span class="reason-author">Comment added by Admin</span>
    </div>
    <div class="modal-footer">
      <button
        class="btn-confirm-approve"
        (click)="closeViewReasonModal()"
        style="background: #4f46e5; border-color: #4f46e5; padding: 10px 24px"
      >
        Close
      </button>
    </div>
  </div>
</div>
<div
  class="modal-backdrop"
  *ngIf="showViewClarificationModal && selectedCompany"
>
  <div class="modal-card reason-modal">
    <button class="modal-close-btn" (click)="closeViewClarificationModal()">
      <span class="material-icons">close</span>
    </button>

    <div class="modal-company-header">
      <div
        class="avatar"
        [style.background-color]="
          selectedCompany.logo_url ? 'transparent' : '#6366f1'
        "
      >
        <img
          *ngIf="selectedCompany.logo_url"
          [src]="selectedCompany.logo_url"
          alt="Logo"
          class="company-logo-img"
        />
        <span *ngIf="!selectedCompany.logo_url">
          {{ selectedCompany.company_name.substring(0, 2).toUpperCase() }}
        </span>
      </div>
      <div class="company-info">
        <h2 class="modal-title">{{ selectedCompany.company_name }}</h2>
        <p class="company-industry">{{ selectedCompany.industry }}</p>
      </div>
    </div>
    
    <div class="status-section">
      <span class="status-label" style="margin-right: 8px">STATUS</span>
      <span class="badge-dot need_clarification">
        <span class="dot"></span>
        need clarification
      </span>
    </div>

    <div class="reason-content-box clarification-box">
      <div class="reason-header">
        <span class="material-icons reason-icon">help_outline</span>
        <span class="reason-title">REASON FOR CLARIFICATION</span>
      </div>
      <p class="reason-text">
        {{
          selectedCompany.clarification_reason ||
            "No clarification details provided."
        }}
      </p>
      <span class="reason-author">Comment added by Admin</span>
    </div>

    <div class="modal-footer">
      <button
        class="btn-confirm-approve"
        (click)="closeViewClarificationModal()"
        style="background: #4f46e5; border-color: #4f46e5; padding: 10px 24px"
      >
        Close
      </button>
    </div>
  </div>
</div>
<ng-template #showMessage>
  <div class="no-data">
    <span class="material-icons">search_off</span>
    <h3>No company requests found</h3>
    <p>Try adjusting your search or filters</p>
    <button class="reset-filter-btn" (click)="resetFilters()">
      <span class="material-icons">restart_alt</span> Clear Filters
    </button>
  </div>
</ng-template>
